@let form = artworkMetaForm();
@let isReadonly = readonly();
<dx-grid mq1="12/*" mq3="6-6/2-4-6/6-6/6-6/3-3-3-3/6-(6)/12" mq4="6-6/2-4-6/6-6/6-6/2-2-2-2-4/12" [formGroup]="form">
  <dx-text-input
    required="true"
    formControlName="title"
    label="{{ 'artwork.title' | transloco }}"
    [readonly]="isReadonly"
  ></dx-text-input>
  <dx-combobox
    formControlName="artist"
    usagemode="new"
    required="true"
    label="{{ 'artwork.artist' | transloco }}"
    id="combobox"
    (search)="searchManufacturers($event)"
    [transformvalue]="transformValue"
    (valueComplete)="selectManufacturer($event)"
    emptysearchtext="{{ 'artwork.combobox.empty-search-text' | transloco }}"
    loadingtext="{{ 'artwork.combobox.loading-text' | transloco }}"
    placeholder=""
    [readonly]="isReadonly"
  ></dx-combobox>
  <dx-number-input
    min="1000"
    nominmaxlabel="true"
    precision="0"
    limitlength="4"
    thousandseparator="false"
    formControlName="year"
    label="{{ 'artwork.year' | transloco }}"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'artwork.error-message.year-format' | transloco"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-dropdown
    required="true"
    formControlName="mediumId"
    label="{{ 'artwork.medium' | transloco }}"
    [readonly]="isReadonly"
  >
    @for (medium of mediumStore.paginatedMedium()?.elements; track medium) {
      <dx-dropdown-option [value]="medium.id" label="{{ medium.name }}"></dx-dropdown-option>
    }
  </dx-dropdown>
  <dx-dropdown
    required="true"
    formControlName="customsId"
    label="{{ 'artwork.customsId' | transloco }}"
    [readonly]="isReadonly"
  >
    @for (customsIdElement of customsIdStore.paginatedCustomsId()?.elements; track customsIdElement) {
      <dx-dropdown-option [value]="customsIdElement.id" label="{{ customsIdElement.customsId }}"></dx-dropdown-option>
    }
  </dx-dropdown>
  <dx-dropdown
    label="{{ 'artwork.passepartout' | transloco }}"
    (valueChange)="updatePassepartoutValues($event)"
    formControlName="passepartoutId"
    [readonly]="isReadonly"
  >
    <dx-dropdown-option
      [value]="FrameOption.CustomPassepartout"
      label="{{ 'artwork.passepartout-artist-option' | transloco }}"
    ></dx-dropdown-option>
    @for (
      passepartout of paginatedFrame()?.elements
        | filterByProperty: "frameType" : "PASSEPARTOUT"
        | filterByProperty: "isCustom" : false;
      track passepartout.id
    ) {
      <dx-dropdown-option [value]="passepartout.id" label="{{ passepartout.description }}"></dx-dropdown-option>
    }
  </dx-dropdown>
  <dx-text-input
    label="{{ 'artwork.passepartout-artist-option' | transloco }}"
    formControlName="passepartoutDetails"
    [required]="true"
    [readonly]="isReadonly"
    [style]="{ display: showCustomPassepartout() ? 'block' : 'none' }"
  ></dx-text-input>
  <dx-dropdown
    label="{{ 'artwork.frame' | transloco }}"
    (valueChange)="updateFrameValues($event)"
    formControlName="frameId"
    [readonly]="isReadonly"
  >
    <dx-dropdown-option
      [value]="FrameOption.CustomFrame"
      label="{{ 'artwork.frame-artist-option' | transloco }}"
    ></dx-dropdown-option>
    @for (
      frame of paginatedFrame()?.elements
        | filterByProperty: "frameType" : "FRAME"
        | filterByProperty: "isCustom" : false;
      track frame.id
    ) {
      <dx-dropdown-option [value]="frame.id" label="{{ frame.description }}"></dx-dropdown-option>
    }
  </dx-dropdown>
  <dx-text-input
    label="{{ 'artwork.frame-artist-option' | transloco }}"
    formControlName="frameDetails"
    [required]="true"
    [readonly]="isReadonly"
    [style]="{ display: showCustomFrame() ? 'block' : 'none' }"
  ></dx-text-input>

  <dx-number-input
    required="true"
    formControlName="width"
    label="{{ 'artwork.width' | transloco }}"
    min="0"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: -1 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-number-input
    required="true"
    formControlName="height"
    label="{{ 'artwork.height' | transloco }}"
    min="0"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: -1 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-number-input
    required="true"
    formControlName="depth"
    label="{{ 'artwork.depth' | transloco }}"
    min="0"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: -1 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-number-input
    formControlName="weight"
    label="{{ 'artwork.weight' | transloco }}"
    min="0"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: -1 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-dropdown formControlName="aidaProperty" label="{{ 'artwork.aidaProperty' | transloco }}" [readonly]="isReadonly">
    @for (aidaPropertyOption of aidaPropertyOptions; track aidaPropertyOption.value) {
      <dx-dropdown-option
        [value]="aidaPropertyOption.value"
        label="{{ aidaPropertyOption.label | transloco }}"
      ></dx-dropdown-option>
    }
  </dx-dropdown>
  <dx-checkbox
    formControlName="closedEdition"
    label="{{ 'artwork.checkbox.closed-edition' | transloco }}"
    [readonly]="isReadonly"
  ></dx-checkbox>
</dx-grid>
